export const plateOptions = [
  { id: "شخصی", title: "شخصی" },
  { id: "افراد جانباز و معلول", title: "افراد جانباز و معلول" },
  { id: "دولتی", title: "دولتی" },
];
